<!-- @veltra/icons generated sha256:20012f8d7f6c23c8 gen:8 source:src/svg/normal/form-container.svg -->
<script setup lang="ts">
defineOptions({ name: 'FormContainer' })
</script>
<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
    <rect
      width="14"
      height="10"
      x="1"
      y="3"
      fill="none"
      stroke="currentColor"
      stroke-width="1.2"
      rx="1.5"
    />
    <path
      stroke="currentColor"
      stroke-linecap="round"
      stroke-width="1.2"
      d="M3.5 6h2m2 0h5m-9 4h2m2 0h5"
    />
  </svg>
</template>
